import React, { FC, useCallback, useLayoutEffect, useRef } from 'react'

import { useScroll } from 'shared/hooks'
import { GlobalizedArtistInfo, GlobalizedProjectNavTabs, LocalizeProjectButton } from 'modules/Globalize/containers'
import { ProjectEditButton } from 'modules/Projects/containers'
import { ArchivedAlert } from 'components'
import { useArtistInfo } from 'modules/Projects/serviceHooks'

import styles from './project-detail.module.scss'
import { useParams } from 'react-router-dom'
import { TRouterParams } from 'shared/types'
import { Can } from 'shared/abilities'

export const GlobalProjectTop: FC = () => {
  const { id } = useParams<TRouterParams>()
  const { activeArtist, activeProject } = useArtistInfo(id)
  const container = useRef<HTMLDivElement>()

  const [refProxy] = useScroll((ref, offset) => {
    if (offset <= 60) {
      ref.style.setProperty('--sbx-scroll-top', offset + 'px')

      // Complete prev animation
      ref.style.setProperty('--sbx-scroll-height', '0px')
      ref.style.setProperty('--sbx-scroll-opacity', '1')
    }
    if (offset > 60) {
      ref.style.setProperty('--sbx-scroll-height', offset - 60 + 'px')
      ref.style.setProperty('--sbx-scroll-opacity', (1 - (offset - 60) / 110).toString())

      // Complete prev animation
      ref.style.setProperty('--sbx-scroll-top', 60 + 'px')
    }
  }, 170)

  const proxyContainer = useCallback(
    (el: HTMLHeadingElement) => {
      container.current = el
      refProxy(el)
    },
    [refProxy]
  )

  useLayoutEffect(() => {
    setTimeout(() => {
      if (container.current) {
        container.current.classList.add(styles.mount)
      }
    }, 100)
  }, [])

  return (
    <div ref={proxyContainer} className={styles.top}>
      <div className={styles.container} data-edit-mode-header>
        <div className={styles.wrapper}>
          <GlobalizedArtistInfo activeArtist={activeArtist} activeProject={activeProject} />
          <div className={styles.middle}>
            {activeProject.active === false ? <ArchivedAlert /> : null}
          </div>
          <div className={styles.row}>
            <div className={styles.nav}>
              <GlobalizedProjectNavTabs />
            </div>
            <div className={styles.btns}>
              <Can I={'edit'} a={'GlobalProject'}>
                <ProjectEditButton />
              </Can>
              {activeProject.active ? <LocalizeProjectButton /> : null}
            </div>
          </div>
          <div className={styles.navMain}>
            <GlobalizedProjectNavTabs />
          </div>
        </div>
      </div>
    </div>
  )
}
